export const GET_ALL_REPORTS = 'GET_ALL_REPORTS'
export const GET_ALL_REPORTS_SUCCESS = 'GET_ALL_REPORTS_SUCCESS'
export const GET_ALL_REPORTS_FAIL = 'GET_ALL_REPORTS_FAIL'
export const CLEAR_ALL_REPORTS_DATA = 'CLEAR_ALL_REPORTS_DATA'
